jQuery(($) => {

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Smooth Scroll to Anchors
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('body').on('click', 'a', function (event) {
    // Check if the href attribute contains an anchor
    const url = $(this).attr('href');
    const hashIndex = url.indexOf('#');

    if (hashIndex >= 0) {
      const anchor = url.slice(hashIndex + 1);

      // If the anchor exists on the page
      if ($('#' + anchor).length) {
        event.preventDefault();

        // Animate the scroll to the anchor's position
        $('html, body').animate({
          scrollTop: $('#' + anchor).offset().top - 110
        }, 500);  // 500ms animation speed

        $('#' + anchor).focus();

        // Update the URL in the browser (optional)
        if (history.pushState) {
          history.pushState(null, null, '#' + anchor);
        } else {
          location.hash = '#' + anchor;
        }
      }
    }
  });
});
